import React from 'react';
import PropTypes from 'prop-types';
import { Grid, IconButton } from '@mui/material';
import { CheckBox, CheckBoxOutlineBlank } from '@mui/icons-material';

const renderCheckboxIcon = (allSelected) => {
  return allSelected ? <CheckBox color="primary" /> : <CheckBoxOutlineBlank />;
};

const getSelectAllTitle = (allSelected) => {
  return allSelected ? 'Deselect All' : 'Select All';
};

const SelectAllButton = ({ selectedAccounts, filteredData, toggleSelectAll }) => {
  const allSelected = selectedAccounts.length === filteredData.length;
  return (
    <Grid
      sx={{ minWidth: 'auto', width: selectedAccounts.length > 0 ? 'auto' : 0, overflow: 'hidden', transition: 'width 0.2s' }}>
      {selectedAccounts.length > 0 && (
        <IconButton
          onClick={toggleSelectAll}
          title={getSelectAllTitle(allSelected)}
          sx={{ p: 1 }}
        >
          {renderCheckboxIcon(allSelected)}
        </IconButton>
      )}
    </Grid>
  );
};

SelectAllButton.propTypes = {
  selectedAccounts: PropTypes.array.isRequired,
  filteredData: PropTypes.array.isRequired,
  toggleSelectAll: PropTypes.func.isRequired
};

export default SelectAllButton;